import { configureStore } from '@reduxjs/toolkit';
import appDetailsReducer from './appBuilder/appDetails';
import appStepperDetailsReducer from './appBuilder/stepperDetails';
import manualVerificationProviderDetailsReducer from './manualVerification/providerDetails';
import manualVerificationSessionDetailsReducer from './manualVerification/sessionsDetails';
import manualVerificationStepperDetailsReducer from './manualVerification/stepperDetails';
import manualVerificationTemporaryDetailsReducer from './manualVerification/temporaryDetails';
import jsonViewerReducer from './providerBuilder/jsonViewer';
import mobileClientReducer from './providerBuilder/mobileClient';
import networkRequestStoreReducer from './providerBuilder/networkRequestStore';
import providerDetailsReducer from './providerBuilder/providerDetails';
import selectedInstancesReducer from './providerBuilder/selectedInstances';
import selectedNetworkRequestReducer from './providerBuilder/selectedNetworkRequest';
import stepperDetailsReducer from './providerBuilder/stepperDetails';
import viewAppAnalyticsReducer from './viewApp/appAnalytics';
import viewAppStepperDetailsReducer from './viewApp/stepperDetails';
import applicationReducer from './applications';
import httpsProvidersReducer from './httpsProviders';
import sessionReducer from './session';
import userReducer from './user';
import { paymentsApi } from './payments/payments';
import userDetailsReducer from './admin/userDetails';

const store = configureStore({
  reducer: {
    user: userReducer,
    application: applicationReducer,
    appDetails: appDetailsReducer,
    appAnalytics: viewAppAnalyticsReducer,
    appStepperDetails: appStepperDetailsReducer,
    httpsProviders: httpsProvidersReducer,
    session: sessionReducer,
    networkRequestStore: networkRequestStoreReducer,
    stepperDetails: stepperDetailsReducer,
    selectedNetworkRequest: selectedNetworkRequestReducer,
    selectedInstances: selectedInstancesReducer,
    providerDetails: providerDetailsReducer,
    mobileClient: mobileClientReducer,
    jsonViewer: jsonViewerReducer,
    manualVerificationStepperDetails: manualVerificationStepperDetailsReducer,
    manualVerificationProviderDetails: manualVerificationProviderDetailsReducer,
    viewAppStepperDetails: viewAppStepperDetailsReducer,
    manualVerificationSessionDetails: manualVerificationSessionDetailsReducer,
    manualVerificationTemporaryDetails: manualVerificationTemporaryDetailsReducer,
    userDetails: userDetailsReducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
  },
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(paymentsApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
